(() => {
  const fixPrivacyLink = () => {
    document.querySelectorAll('a[href*="/policies/privacy-policy"]').forEach((link) => {
      if (link.textContent.trim().toLowerCase() === 'learn more') {
        link.textContent = 'Privacy Policy';
        link.setAttribute('aria-label', 'Privacy Policy');
      }
    });
  };

  fixPrivacyLink();

  const observer = new MutationObserver(fixPrivacyLink);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
